<div class="lvi-content list-view-item-hover">
    <div class="avatar" [class.danger]="!!data.nbRejet || !!data.nbExclue || !!data.nbErreur">
        <i class="material-icons-outlined">credit_card</i>
    </div>
    <div class="lvi-body" (click)="showHistory()">
        <div class="title">
            <a>
                {{ typeLibelle }}
            </a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.frais.cartes.suivi.numero'"></strong>
                <span>{{ data.idOpeLog }}</span>
            </li>
            <li>
                <strong [translate]="'admin.frais.cartes.suivi.date'"></strong>
                <span>{{ data.date | date: 'shortDate' }} {{ data.date | date: 'mediumTime' }}</span>
            </li>
            <li>
                <strong [translate]="'admin.frais.cartes.suivi.nbOpe'"></strong>
                <span>{{ data.nbOpe }}</span>
            </li>
            <li>
                <strong [translate]="'admin.frais.cartes.suivi.correctes'"></strong>
                <span>{{ data.nbCorrect }}</span>
            </li>
            <li [class.li-danger]="!!data.nbRejet" [nioTooltip]="!!data.nbRejet && ('admin.frais.cartes.suivi.tooltipRejetees' | translate)">
                <mat-icon *ngIf="!!data.nbRejet" class="material-icons-outlined error-icon">info</mat-icon>
                <strong [translate]="'admin.frais.cartes.suivi.rejetees'"></strong>
                <span>{{ data.nbRejet }}</span>
            </li>
            <li [class.li-danger]="!!data.nbExclue" [nioTooltip]="!!data.nbExclue && ('admin.frais.cartes.suivi.tooltipExclues' | translate)">
                <mat-icon *ngIf="!!data.nbExclue" class="material-icons-outlined error-icon">info</mat-icon>
                <strong [translate]="'admin.frais.cartes.suivi.exclues'"></strong>
                <span>{{ data.nbExclue }}</span>
            </li>
            <li [class.li-danger]="!!data.nbErreur" [nioTooltip]="!!data.nbErreur && ('admin.frais.cartes.suivi.tooltipErreur' | translate)">
                <mat-icon *ngIf="!!data.nbErreur" class="material-icons-outlined error-icon">info</mat-icon>
                <strong [translate]="'admin.frais.cartes.suivi.enErreur'"></strong>
                <span>{{ data.nbErreur }}</span>
            </li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button (click)="showHistory(); $event.stopPropagation()">
            <mat-icon *ngIf="isOuvert" color="primary" [matTooltip]="'od.voyage.replier' | translate">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="!isOuvert" color="primary" [matTooltip]="'od.voyage.deplier' | translate">keyboard_arrow_down</mat-icon>
        </button>
    </div>
</div>
<div *ngIf="isOuvert" [ngStyle]="{'padding': '10px 0px'}">
    <suivi-releve-history-item
            *ngFor="let historyItem of listeHistorique"
            [opeLog]="historyItem"
            [liste]="liste"
            (onOpenErrorList)="onOpenErrorList($event)">
    </suivi-releve-history-item>
</div>